import axios from 'axios';
export default class PurchaseService {
    async GetPurchaseList(data) {
        return await axios .post('api/v1/admin/purchase/list', data);
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_date,
    //         })
    //         .then((res) => res);
    // }
    async viewPurchase(ids) {
        return await axios
            .post(`api/v1/admin/purchase/detail-purchase`, {
                purchase_id: ids,
            })
            .then((res) => res.data.result);
    }
    async UpdatePurchase(data) {
        return await axios
            .post(`api/v1/admin/purchase/update-purchase`, data)
            .then((res) => res);
    }
    async SearchPurchase(data) {
        return await axios
            .post(`api/v1/admin/purchase/search-user`, data)
            .then((res) => res);
    }
    async GetAddTypeList(data) {
        return await axios
            .get(`api/v1/admin/purchase/ad-types`, data)
            .then((res) => res);
    }
    async GetAddSubTypeList(ad_type_id) {
        return await axios
            .post(`api/v1/admin/purchase/ad-sub-types`,{ad_type_id:ad_type_id})
            .then((res) => res);
    }
    async viewSubTypeDetails(sub_type_id) {
        return await axios
            .post(`api/v1/admin/ad-type/details`, {
                sub_type_id: sub_type_id,
            })
            .then((res) => res.data.result);
    }
}
